import { createFileRoute } from '@tanstack/react-router'
import PublicSchedule from '@/pages/public-schedule'

export const Route = createFileRoute('/schedule/$token')({
  component: PublicSchedule,
})
